'use client';

import React, { useMemo, type ReactNode } from 'react';
import { AnalyticsProvider } from '@/contexts/AnalyticsContext';
import RouteAnalytics from '@/components/RouteAnalytics';
import { AmplitudeAdapter, ConsoleAdapter } from '@/lib/analytics';

interface Props {
  apiKey?: string;
  // Set to 'Spreadd' to pin all events to a single shared identity.
  // Remove to switch to per-user tracking.
  sharedUserId?: string;
  children: ReactNode;
}

export default function AnalyticsBootstrap({ apiKey, sharedUserId, children }: Props) {
  // Adapter is created client-side — class instances can't cross the server/client boundary
  const adapter = useMemo(
    () => (apiKey ? new AmplitudeAdapter() : new ConsoleAdapter()),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // intentionally stable — adapter type is fixed for the lifetime of the page
  );

  return (
    <AnalyticsProvider adapter={adapter} apiKey={apiKey ?? ''} sharedUserId={sharedUserId}>
      <RouteAnalytics />
      {children}
    </AnalyticsProvider>
  );
}
